<template lang="pug">
.open-system-container(v-if="show", @touchmove.prevent)
  .open-system-block
    .open-stytem-close(@click="closeModal")
      img(src="https://m.hellobike.com/resource/helloyun/08345/bMneu_x9N6.png")
    .open-system-title 请先升级APP版本
    .open-system-word 抱歉，您的App版本过低，请前往应用商店，
    .open-system-word 更新至最新版本
    .open-read-btn(@click="updateApp") 去更新
  .shadow()
</template>

<script>
import { commonGoLink } from '@/utils';
import { PROTOCOL_URL } from '../../common/const';
import { copyHaCodeAndJumpToAppMarket } from '../../common/helper';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    haCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    goRenewal() {
      commonGoLink(PROTOCOL_URL.RENEWAL, { isRuleLink: true });
    },
    goMember() {
      commonGoLink(PROTOCOL_URL.MEMBER, { isRuleLink: true });
    },
    updateApp() {
      this.$emit('confirm');
      this.$emit('close');
      copyHaCodeAndJumpToAppMarket(this.haCode);
    },
  },

};
</script>
<style lang="less" scoped>
.open-system-container {
  position: fixed;
  bottom: 0;
  z-index: 300;
  width: 100%;

  .open-system-block {
    width: 100%;
    height: 2.44rem;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0 0;
    z-index: 101;
    position: relative;
    padding-top: 0.2rem;
    display: flex;
    flex-direction: column;

    .open-stytem-close {
      position: absolute;
      top: 0.14rem;
      right: 0.14rem;

      img {
        width: 0.16rem;
        height: 0.16rem;
        display: block;
      }
    }

    .open-system-title {
      text-align: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
      margin-bottom: 0.24rem;
    }

    .open-system-word {
      text-align: center;
      font-size: 0.14rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #242729;
      line-height: 0.2rem;

      .orange-word {
        color: #08f;
      }
    }

    .open-read-btn {
      margin: 0.28rem auto 0;
      font-size: 0.16rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      width: 3.35rem;
      height: 0.48rem;
      line-height: 0.48rem;
      font-weight: 600;
      color: #fff;
      background: #08f;
      border-radius: 0.48rem;
      text-align: center;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
